import { render, staticRenderFns } from "./CompanySubscriptions.vue?vue&type=template&id=5519ce7b&"
import script from "./CompanySubscriptions.vue?vue&type=script&lang=ts&"
export * from "./CompanySubscriptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5519ce7b')) {
      api.createRecord('5519ce7b', component.options)
    } else {
      api.reload('5519ce7b', component.options)
    }
    module.hot.accept("./CompanySubscriptions.vue?vue&type=template&id=5519ce7b&", function () {
      api.rerender('5519ce7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanySubscriptions.vue"
export default component.exports